import { BaseEntity } from "yt-ng-framework";

export class PojedinacnaEvidencijaPdv extends BaseEntity{
    constructor(){
        super();
    };

    BrojDokumenta:string = null;
    BrojObracuna:string = null;
    DatumDokumenta:Date = null;
    DatumPlacanja:Date = null;
    TipDokumentaSefId:number = null;
    Godina:number = null;
    Opis: string = null;
    UkupanIznosNaknade: number = null;
    OsnovicaPdvStopa20: number = 0;
    OsnovicaPdvStopa10: number = null;
    ObracunatiPdv: number = null;
    ObracunatiPdvStopa10: number = null;
    ObracunatiPdvStopa20: number = null;
    UkupanIznosOsnovice: number = null;
    BrojPovezanogDokumenta: string = null;
    PravacDokumentaId: number = null;
    KomitentID: number = null;
    OpisPrometaStopa20: string = null;
    OpisPrometaStopa10: string = null;
    PeriodId: number = null;
    InterniObracun: string = null;
    BrojAvansnogRacuna: string = null;
    OsnovZaAvansnoPlacanje: string = null;
    PravoNaOdbitakPdv: string = null;
    InoFaktura: boolean = null;
    MasterDokumID: number = null;
    FakDokumMasterDokumID: number = null;
    PoreskiPeriodId: number = null;
    IdentifikatorPosiljaoca: string = null;
    OsvezivogStatusa: boolean= null;
    ProvajderID: number=null;
    StatusColor: string = null;
    StatusGenericName: string = null;
    PodvrstaDokumentaStavkaId: number = null;
    DatumObracuna: Date = null;
    TipDokumenta: string = null;
    RelatedInvoiceOption: number = null;
    RelatedVatRecordOutOfSystem: string = null;
    RelatedVatRecords: string = null;
    RelatedInvoiceIssueDateFrom: Date = null;
    RelatedInvoiceIssueDateTo: Date = null;
    RelatedDocuments: string = null;
    EdokumentID: string = null;
    StatusTooltip: string = null;
    
    Deserialize(input: any) {
        super.Deserialize(input);
        this.ID = input.ID;
        this.BrojDokumenta = input.BrojDokumenta;
        this.BrojObracuna = input.BrojObracuna;
        this.DatumDokumenta = input.DatumDokumenta;
        this.DatumPlacanja = input.DatumPlacanja;
        this.TipDokumentaSefId = input.TipDokumentaSefId;
        this.Godina = input.Godina;
        this.Opis = input.Opis;
        this.UkupanIznosNaknade = input.UkupanIznosNaknade;
        this.OsnovicaPdvStopa20 = input.OsnovicaPdvStopa20;
        this.OsnovicaPdvStopa10 = input.OsnovicaPdvStopa10;
        this.ObracunatiPdv = input.ObracunatiPdv;
        this.ObracunatiPdvStopa10 = input.ObracunatiPdvStopa10;
        this.ObracunatiPdvStopa20 = input.ObracunatiPdvStopa20;
        this.UkupanIznosOsnovice = input.UkupanIznosOsnovice;
        this.BrojPovezanogDokumenta = input.BrojPovezanogDokumenta;
        this.PravacDokumentaId = input.PravacDokumentaId;
        this.KomitentID = input.KomitentID;
        this.OpisPrometaStopa20 = input.OpisPrometaStopa20;
        this.OpisPrometaStopa10 = input.OpisPrometaStopa10;
        this.PeriodId = input.PeriodId;
        this.InterniObracun = input.InterniObracun;
        this.BrojAvansnogRacuna = input.BrojAvansnogRacuna;
        this.OsnovZaAvansnoPlacanje = input.OsnovZaAvansnoPlacanje;
        this.PravoNaOdbitakPdv = input.PravoNaOdbitakPdv;
        this.InoFaktura = input.InoFaktura;
        //this.OrgJedId = input.OrgJedId;
        this.MasterDokumID = input.MasterDokumID;
        this.FakDokumMasterDokumID = input.FakDokumMasterDokumID;
        this.PoreskiPeriodId = input.PoreskiPeriodId;
        this.IdentifikatorPosiljaoca = input.IdentifikatorPosiljaoca;
        this.OsvezivogStatusa=input.OsvezivogStatusa;
        this.ProvajderID=input.ProvajderID;
        this.StatusColor = input.StatusColor;
        this.StatusGenericName = input.StatusGenericName;
        this.PodvrstaDokumentaStavkaId = input.PodvrstaDokumentaStavkaId;
        this.DatumObracuna = input.DatumObracuna;
        this.TipDokumenta = input.TipDokumenta;
        this.RelatedInvoiceOption = input.RelatedInvoiceOption;
        this.RelatedVatRecords = input.RelatedVatRecords;
        this.RelatedVatRecordOutOfSystem = input.RelatedVatRecordOutOfSystem;
        this.RelatedInvoiceIssueDateFrom = input.RelatedInvoiceIssueDateFrom;
        this.RelatedInvoiceIssueDateTo = input.RelatedInvoiceIssueDateTo;
        this.EdokumentID = input.EdokumentID;
        this.StatusTooltip = input.StatusTooltip;
        return this;
    }

    Serialize(input: PojedinacnaEvidencijaPdv){
        return input;
    }

    GetInstance(){
        return this;
    }


}